import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const { VITE_APP_PROJECT_NAME } = import.meta.env;
const { hostname } = window.location;

const firebaseConfigs = {
  gloryStage: {
    apiKey: "AIzaSyDzrJkazslUj5uqa0kTYpLCv4DeewVcmtY",
    authDomain: "glorybetcasino.firebaseapp.com",
    projectId: "glorybetcasino",
    storageBucket: "glorybetcasino.firebasestorage.app",
    messagingSenderId: "1025761900990",
    appId: "1:1025761900990:web:cf75799c946947730721ef",
    measurementId: "G-9VN91EYK6D",
  },

  gloryProd: {
    apiKey: "AIzaSyDgXXHf4HbI3k48L6EOfc99QVP8fyY_srU",
    authDomain: "gloryplaycasino.firebaseapp.com",
    projectId: "gloryplaycasino",
    storageBucket: "gloryplaycasino.firebasestorage.app",
    messagingSenderId: "140240477977",
    appId: "1:140240477977:web:32246b7f7d75d777392f88",
    measurementId: "G-RTDSFXRQB0",
  },

  banger: {
    apiKey: "AIzaSyAVA0Q5jEsvkeowH7sXk9k9FSkJjDrYE-s",
    authDomain: "bangerauthcasino.firebaseapp.com",
    projectId: "bangerauthcasino",
    storageBucket: "bangerauthcasino.firebasestorage.app",
    messagingSenderId: "918553235746",
    appId: "1:918553235746:web:16b24d4e605c642518557b",
    measurementId: "G-8WE5PMT0B0",
  },
};

let selectedConfig;

if (VITE_APP_PROJECT_NAME === "glory" && hostname.includes("stage")) {
  selectedConfig = firebaseConfigs.gloryStage;
} else if (VITE_APP_PROJECT_NAME === "glory") {
  selectedConfig = firebaseConfigs.gloryProd;
} else if (VITE_APP_PROJECT_NAME === "banger") {
  selectedConfig = firebaseConfigs.banger;
} else {
  selectedConfig = firebaseConfigs.gloryProd;
}

const app = !getApps().length ? initializeApp(selectedConfig) : getApp();

const analytics = getAnalytics(app);

export { app, analytics };
